import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import SkeletonLoader from './components/Loaders/SkeletonLoader';

class Spinner extends Component {
    constructor(props) {
        super(props);
        var appState = JSON.parse(localStorage.getItem('appState'))

        this.state = {
            isLoggedIn: appState?.isLoggedIn || false,
        }
    }

    render() {
        // Automatically determine suitable skeleton type based on where we are
        let skeletonType = this.props.type || 'default';
        let count = this.props.count !== undefined ? this.props.count : 3;

        const pathname = this.props.location?.pathname || "";
        if (pathname.toLowerCase().includes("logout")) {
            skeletonType = 'logout';
            count = 1;
        } else if (pathname.includes("invoice")) {
            skeletonType = 'invoice';
            count = 1;
        } else if (pathname.includes("history")) {
            skeletonType = 'account-history';
            count = 1;
        } else if (pathname.includes("wishlist")) {
            skeletonType = 'wishlist';
            count = 1;
        } else if (pathname === "/product" || pathname === "/product/") {
            skeletonType = 'product-detail';
            count = 1;
        } else if (pathname.includes("product-listing") || pathname.includes("listing") || pathname.includes("category")) {
            skeletonType = 'product-listing';
            count = 1;
        } else if (pathname.includes("addresses")) {
            skeletonType = 'feature-card';
            count = 2;
        } else if (pathname.includes("details")) {
            skeletonType = 'account-details';
            count = 1;
        } else if (pathname.includes("cart")) {
            skeletonType = 'cart';
            count = 1;
        }

        if (this.props.isProductCard) {
            return <SkeletonLoader type="product-vertical" count={1} isProductCard={true} />;
        }

        return (
            <div style={{ padding: '20px 0', width: '100%' }}>
                <SkeletonLoader type={skeletonType} count={count} />
            </div>
        );
    }
}

export default withRouter(Spinner);
